import { render, staticRenderFns } from "./LoginForm.vue?vue&type=template&id=8df38804&scoped=true"
import script from "./LoginForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginForm.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LoginForm.vue?vue&type=style&index=0&id=8df38804&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df38804",
  null
  
)

export default component.exports